<template>
    <div class="main-container">

        <!-- Navbar section -->
        <Navbar />

        <!-- hero section -->
        <HeroBranding />

        <!--<div class="box-image-area section-space--ptb_60 m-t-50vh" id="about">
            <div class="container mobile-mw-100">
                <div class="section-title-wrapper text-center section-space--mb_15 wow move-up">
                    <p id="titreLien" class="main-title mb-15">{{ $t('homePage.purchase3DTitle') }}</p>
                    <p class="section-text py-3">{{ $t('homePage.purchase3DText') }}</p>
                </div>
                <div class="row box-image-wrapper d-flex flex-row justify-content-center">
                    <div class="box-image__media d-flex flex-row justify-content-center wow move-up width-50 mobile-w-100">
                        <img class="w-65 mobile-w-90 sm-to-lg-mobile-w-50 tablet-w-100" src="../assets/img/hero/branding/3d-prints.png" >
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Section 1 -->
        <div class="feature-icon-list-area">
            <div class="requirements-list-area requirements-list-area-background py-5">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-sm-12 col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('homePage.section1Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('homePage.section1Text') }}</p>
                            <div class="tab-button wow move-up">
                                <router-link :to="$t('links.contactUs')" class="ht-btn ht-btn-md">{{ $t('general.moreInfoBtn') }}</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/wax-print.png" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div>

        <!-- Section 2 -->
        <div class="feature-icon-list-area">
            <div class="requirements-list-area py-5" id="requirement">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('homePage.section2Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('homePage.section2Text') }}</p>
                            <ul class="requirements-list__items wow move-up">
                                <li>
                                    <strong>{{ $t('homePage.section2bullet3Title') }}</strong>
                                    {{ $t('homePage.section2bullet3Text') }}
                                </li>
                                <li>
                                    <strong>{{ $t('homePage.section2bullet1Title') }}</strong>
                                    {{ $t('homePage.section2bullet1Text') }}
                                </li>
                                <li>
                                    <strong>{{ $t('homePage.section2bullet2Title') }}</strong>
                                    {{ $t('homePage.section2bullet2Text') }}
                                </li>                                
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/home-2-new.png" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div>

        <!-- Section 3 -->
        <div class="feature-icon-list-area">
            <div class="requirements-list-area-background py-5" id="requirement">
                <div class="row align-items-center mw-100 mx-auto">
                    <div class="col-lg-6 order-2 order-xl-1">
                        <div class="requirements-list">
                            <p class="main-title mb-30 wow move-up">{{ $t('homePage.section3Title') }}</p>
                            <p class="requirements-list__text heading mb-30 wow move-up mobile-mw-100 tablet-mw-100">{{ $t('homePage.section3Text') }}</p>
                            <div class="tab-button wow move-up">
                                <router-link :to="$t('links.contactUs')" class="ht-btn ht-btn-md">{{ $t('general.moreInfoBtn') }}</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 order-12 order-xl-1 d-flex justify-content-center">
                        <img src="../assets/img/3d/home-3-new.png" class="img-fluid w-65 tablet-width-75 mobile-w-90 sm-to-lg-mobile-w-50" width="514.141px" height="440.219px">
                    </div>
                </div>
            </div>
        </div>

        <!-- featured elements section -->
        <!-- <FeatureList /> -->
        <!-- <RequireList /> -->
        <!-- <ServicesList /> -->

        <!-- footer section -->
        <FooterMain />
    </div>
</template>

<script>
    import Navbar from '../components/Navbar.vue'
    import HeroBranding from '../components/HeroBranding.vue'
    import FeatureList from '../components/FeatureList.vue'
    import RequireList from '../components/RequireList.vue'
    import ServicesList from '../components/ServicesList.vue'
    import FooterMain from '../components/FooterMain.vue'

    export default {
        name: 'app',
        components: {
            Navbar,
            HeroBranding,
            FeatureList,
            RequireList,
            ServicesList,
            FooterMain,
        },
		data(){
			return{
				testVar1 : process.env.VUE_APP_GTAG_UA
			}
		},
        metaInfo(){
            return {
                title: this.$i18n.t('tabTitle.home'),
                meta: [
                    { "name": "description", "content":  this.$i18n.t('meta.description.home') },
                    { "name": "theme-color", "content": "#007BFF;" }
                ]
            }
        },
        created(){
            if(typeof window.gtag !== 'undefined'){
                window.gtag('config', process.env.VUE_APP_GTAG_UA, {
                'page_title' : this.$i18n.t('tabTitle.home'),
                'page_path': this.$i18n.t('links.accueil')
                });
                window.gtag('config', process.env.VUE_APP_GTAG_G, {
                    'page_title' : this.$i18n.t('tabTitle.home'),
                    'page_path': this.$i18n.t('links.accueil')
                });
            }
            if(typeof window.fbq !== 'undefined'){
                window.fbq('track', 'PageView');
            }
        }
    }
</script>
